export * from "./createchild.component";
export * from "./viewchild.component";
export * from "./childmodal.component";
export * from "./searchchildmodal.component";



// WEBPACK FOOTER //
// ./src/app/child/index.ts